//DEFAULTS
window.mobileBreakpoint = 1300;
import "imports/core-js/stable";
import "imports/regenerator-runtime/runtime";
import site from 'site/site'
import simpleSlideshowPrep from "site/simpleSlideshowPrep"
import audioPlayer from "site/audioPlayer"
import popup from "site/popup"
import gsap from 'imports/gsap'
$(document).ready(function() {
    //stickOverlay.init()

    site.init()
    //audioPlayer.init()
    simpleSlideshowPrep.init()
    popup.init()
})
